var React = require('react');
var STAKE = require('../stake-placement');
var router = require('react-router');
var Link = router.Link;

var encodeSlug = require('../room-slug');
var roomsWithSchedules = require('../rooms-with-schedules');

var STATE_HUBS = require('../state-hubs');
var METRO_HUBS = require('../metro-hubs');
var buildHubFaq = require('../hub-faq');
var SiteFooter = require('../site-footer');
var sections = require('../hub-sections');

var scheduleSet = {};
(roomsWithSchedules || []).forEach(function(name) {
  scheduleSet[name] = true;
});

function roomHasSchedule(room) {
  if (!room) { return false; }
  if (room.schedules && room.schedules.length) { return true; }
  return !!scheduleSet[room.name];
}

function orderedHubRooms(rooms) {
  return (rooms || []).slice().sort(function(a, b) {
    var aSched = roomHasSchedule(a) ? 1 : 0;
    var bSched = roomHasSchedule(b) ? 1 : 0;
    if (aSched !== bSched) { return bSched - aSched; }
    var ac = String(a.city || '').localeCompare(String(b.city || ''));
    if (ac) { return ac; }
    return String(a.name || '').localeCompare(String(b.name || ''));
  });
}

var HUBS = {};
Object.keys(STATE_HUBS).forEach(function(slug) {
  HUBS[slug] = STATE_HUBS[slug];
});
Object.keys(METRO_HUBS).forEach(function(slug) {
  HUBS[slug] = METRO_HUBS[slug];
});

var DEDICATED_PATHS = [
  'texas-poker-rooms',
  'california-poker-rooms',
  'washington-poker-rooms',
  'florida-poker-rooms'
].concat(Object.keys(METRO_HUBS));

var SITE = 'https://dailytourneys.com';
var DEFAULT_TITLE = 'Daily Tourneys | U.S. Casino & Poker Room Tournament Schedules';
var DEFAULT_DESC = 'Search daily and weekly poker tournaments at U.S. casinos. Find rooms, compare buy-ins, and see what’s running — free on Daily Tourneys.';

function rememberAttr(el, attr, value) {
  if (!el) { return; }
  if (!el.hasAttribute('data-default')) {
    el.setAttribute('data-default', el.getAttribute(attr) || '');
  }
  el.setAttribute(attr, value);
}

function restoreAttr(el, attr) {
  if (!el) { return; }
  if (el.hasAttribute('data-default')) {
    el.setAttribute(attr, el.getAttribute('data-default'));
  }
}

var HubPage = React.createClass({
  componentDidMount: function() {
    this.setDocTitle();
  },
  componentDidUpdate: function(prevProps) {
    var prev = prevProps.location && prevProps.location.pathname;
    var next = this.props.location && this.props.location.pathname;
    if (prev !== next) {
      this.setDocTitle();
    }
  },
  componentWillUnmount: function() {
    document.title = DEFAULT_TITLE;
    this.restoreHead();
  },
  restoreHead: function() {
    restoreAttr(document.querySelector('meta[name="description"]'), 'content');
    restoreAttr(document.querySelector('meta[property="og:title"]'), 'content');
    restoreAttr(document.querySelector('meta[property="og:description"]'), 'content');
    restoreAttr(document.querySelector('meta[property="og:url"]'), 'content');
    restoreAttr(document.querySelector('meta[name="twitter:title"]'), 'content');
    restoreAttr(document.querySelector('meta[name="twitter:description"]'), 'content');
    restoreAttr(document.querySelector('link[rel="canonical"]'), 'href');
  },
  resolveSlug: function() {
    var path = (this.props.location && this.props.location.pathname) || '';
    var parts = path.split('/').filter(function(part) { return part; });
    if (parts.length === 1 && HUBS[parts[0]]) { return parts[0]; }
    if (parts[0] === 'hubs' && parts[1] && HUBS[parts[1]]) { return parts[1]; }
    var slug = this.props.params && this.props.params.slug;
    return slug || '';
  },
  getHub: function() {
    return HUBS[this.resolveSlug()] || null;
  },
  setDocTitle: function() {
    this.restoreHead();
    var slug = this.resolveSlug();
    var hub = HUBS[slug] || null;
    var title = hub && hub.title ? hub.title : 'Poker Rooms & Casino Tournament Schedules | Daily Tourneys';
    var desc = hub && (hub.description || hub.intro) ? (hub.description || hub.intro) : DEFAULT_DESC;
    document.title = title;
    if (!hub) { return; }
    rememberAttr(document.querySelector('meta[name="description"]'), 'content', desc);
    rememberAttr(document.querySelector('meta[property="og:title"]'), 'content', title);
    rememberAttr(document.querySelector('meta[property="og:description"]'), 'content', desc);
    rememberAttr(document.querySelector('meta[name="twitter:title"]'), 'content', title);
    rememberAttr(document.querySelector('meta[name="twitter:description"]'), 'content', desc);
    var url = SITE + '/' + slug;
    rememberAttr(document.querySelector('link[rel="canonical"]'), 'href', url);
    rememberAttr(document.querySelector('meta[property="og:url"]'), 'content', url);
  },
  cityLinksFor: function(slug) {
    var parentTo = '/' + slug;
    var links = [];
    Object.keys(METRO_HUBS).forEach(function(citySlug) {
      var city = METRO_HUBS[citySlug];
      if (city.parent && city.parent.to === parentTo) {
        links.push({ to: '/' + citySlug, label: city.shortLabel || city.footerLabel });
      }
    });
    return links;
  },
  renderSchedule: function(room, roomSlug) {
    if (!room.schedules) { return null; }
    if (!room.schedules.length) {
      return <p className="hub-schedule-none">No daily/weekly schedule on file yet.</p>;
    }
    var rows = room.schedules.map(function(row, i) {
      var bits = [row.day, row.name, row.start, row.buyin].filter(Boolean);
      return <li className="hub-schedule-row" key={room.name + '-' + i}>{bits.join(' · ')}</li>;
    });
    return (
      <div className="hub-schedule">
        <ul>{rows}</ul>
        <Link className="hub-schedule-more" to={'/allcasinos/' + roomSlug + '/tournaments'}>View tournament schedule</Link>
      </div>
    );
  },
  render: function() {
    var slug = this.resolveSlug();
    var hub = this.getHub();
    var self = this;

    if (!hub) {
      return (
        <div className="content-page hub-page">
          <div className="detail-toolbar">
            <Link to="/" className="back-link">← Back to search</Link>
          </div>
          <h1 className="content-h1">Hub not found</h1>
          <p className="content-lead">No hub content is mapped for “{slug}”. Try Las Vegas or Texas, or search all rooms.</p>
          <p className="content-cta">
            <Link to="/las-vegas-poker-rooms">Las Vegas poker rooms</Link>
            {' · '}
            <Link to="/texas-poker-rooms">Texas poker rooms</Link>
            {' · '}
            <Link to="/">Search all casinos</Link>
          </p>
        </div>
      );
    }

    var ordered = orderedHubRooms(hub.rooms);
    var featured = ordered.filter(roomHasSchedule);
    var featuredNav = null;
    if (featured.length) {
      var featBits = [];
      featured.forEach(function(room, i) {
        if (i > 0) { featBits.push(<span key={'fsep-' + room.name} aria-hidden="true"> · </span>); }
        featBits.push(
          <Link key={'feat-' + room.name} to={'/allcasinos/' + encodeSlug(room.name)}>{room.name}</Link>
        );
      });
      featuredNav = <p className="hub-featured-rooms">Rooms with schedules on file: {featBits}</p>;
    }

    var rooms = ordered.map(function(room) {
      var roomSlug = encodeSlug(room.name);
      var meta = room.city + ', ' + room.state;
      return (
        <li className="hub-card" key={room.name}>
          <Link to={'/allcasinos/' + roomSlug}>
            <span className="casino-result-name">{room.name}</span>
            <span className="casino-result-meta">{meta}</span>
          </Link>
          {self.renderSchedule(room, roomSlug)}
        </li>
      );
    });

    var cityLinks = this.cityLinksFor(slug);
    var cityNav = null;
    if (cityLinks.length) {
      var bits = [];
      cityLinks.forEach(function(item, i) {
        if (i > 0) { bits.push(<span key={'sep-' + item.to} aria-hidden="true"> · </span>); }
        bits.push(<Link key={item.to} to={item.to}>{item.label}</Link>);
      });
      cityNav = <p className="home-intro-links">Cities and regions: {bits}</p>;
    }

    var cta = (
      <p className="content-cta">
        Looking for another city? <Link to="/all-poker-rooms">All poker rooms by state</Link>{' · '}<Link to="/">Search all U.S. poker rooms</Link>
      </p>
    );
    if (hub.parent) {
      cta = (
        <p className="content-cta">
          <Link to={hub.parent.to}>{hub.parent.label}</Link>
          {' · '}
          <Link to="/all-poker-rooms">All poker rooms by state</Link>
          {' · '}
          <Link to="/">Search all U.S. poker rooms</Link>
        </p>
      );
    }

    var faqSection = null;
    var faqItems = METRO_HUBS[slug] ? buildHubFaq(hub) : [];
    if (faqItems.length) {
      faqSection = (
        <section className="hub-faq">
          <h2>{(hub.shortLabel || hub.footerLabel) + ' poker tournament questions'}</h2>
          {faqItems.map(function(item) {
            return (
              <div className="faq-item" key={item.q}>
                <h3>{item.q}</h3>
                <p>{item.a}</p>
              </div>
            );
          })}
        </section>
      );
    }

    var weekSection = null;
    var roomNames = (hub.rooms || []).map(function(room) { return room.name; });
    if (slug === 'houston-poker-rooms') {
      weekSection = <sections.HubWeek areaLabel="Houston" roomNames={roomNames} />;
    } else if (slug === 'san-diego-poker-rooms') {
      weekSection = <sections.HubWeek areaLabel="San Diego" roomNames={roomNames} />;
    } else if (slug === 'texas-poker-rooms') {
      weekSection = <sections.HubWeek areaLabel="Texas" roomNames={roomNames} summary={true} />;
    }

    return (
      <div className="content-page hub-page">
        <div className="detail-toolbar">
          <Link to="/" className="back-link">← Back to search</Link>
        </div>
        <h1 className="content-h1">{hub.h1}</h1>
        <p className="content-lead">{hub.intro}</p>
        {cityNav}
        {weekSection}
        {featuredNav}
        <ul className="hub-grid">
          {rooms}
        </ul>
        <sections.AlsoRooms hub={hub} />
        <sections.CardRooms slug={slug} />
        <sections.Stay slug={slug} />
        {faqSection}
        {STAKE.hubEligible(slug) ? (
          <p className="home-intro-links hub-stake-line">
            {STAKE.hubLine.lead}
            <a href={STAKE.go('hub', slug)} rel="sponsored nofollow">{STAKE.hubLine.joinLabel}</a>
            {' · '}
            <Link to={STAKE.guide}>{STAKE.hubLine.guideLabel}</Link>
          </p>
        ) : null}
        <p className="home-intro-links">
          Spot a mistake? Email info@dailytourneys.com · <Link to="/about">About &amp; data sources</Link>
        </p>
        {cta}
        <SiteFooter />
      </div>
    );
  }
});

module.exports = HubPage;
module.exports.dedicatedPaths = DEDICATED_PATHS;



// WEBPACK FOOTER //
// ./js/pages/hub-page.jsx